import React from "react";

export default function FutureUtility() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr  pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                Future Utility: Staking, Yield Farming & Beyond
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse18"
                          aria-expanded="true"
                          aria-controls="collapse18"
                        >
                          What future benefits do Kryptogram NFT holders get?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse18"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div className="tp-about-2-content">
                            <span>NFT Staking </span>
                            <p className="mb-30">
                              Earn passive rewards by staking your NFT.
                            </p>
                            <span>Yield Farming</span>
                            <p className="mb-30">
                              Earn additional incentives through DeFi programs.
                            </p>
                            <span>Airdrops & Exclusive Perks</span>
                            <p className="mb-30">
                              Access to crypto startup airdrops and blockchain
                              partnerships.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse19"
                          aria-expanded="false"
                          aria-controls="collapse19"
                        >
                          When will NFT staking and yield farming launch?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse19"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Staking and yield farming will be introduced in
                            early 2026 as part of Kryptogram’s blockchain
                            ecosystem expansion.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
}
